import moment from 'moment';
import { get } from 'lodash';
import { fetchPrintInfoList } from '@/api/bill/print';
import { parseFen2Yuan } from '@/utils/number';
import actionTypes from './actionType';

export const toggleLoading = (state) => {
  return {
    type: actionTypes.TOGGLE_LOADING,
    payload: state,
  };
};

export const updateState = (state) => {
  return {
    type: actionTypes.UPDATE_STATE,
    payload: state,
  };
};

export const getPrintInfoList = (data, memberLevelMap) => {
  return async (dispatch) => {
    dispatch(toggleLoading('printInfoListLoading'));
    let orderInfoResponse: any = {};
    let consumeBills = [];
    let paymentBills = [];
    let accountTotal = {};
    let hotelBasicInfoResp = {};
    let orderInfoObj = {};
    try {
      const res = await fetchPrintInfoList(data);
      if (res.code === 0) {
        orderInfoResponse = get(res, 'data.orderInfoResponse', {}) || {};
        consumeBills = get(res, 'data.consumeBills', []) || [];
        paymentBills = get(res, 'data.paymentBills', []) || [];
        accountTotal = get(res, 'data.accountTotal', {}) || {};
        hotelBasicInfoResp = get(res, 'data.hotelBasicInfoResp', {}) || {};
        orderInfoObj = {
          ...orderInfoResponse,
          // 会员等级名称
          memberLevelName: memberLevelMap[orderInfoResponse?.memberLevel]?.name,
          // 有房主取房主，不然取预定人
          masterName: orderInfoResponse?.masterName || orderInfoResponse?.name,
          masterCertNo: orderInfoResponse?.masterCertNo || orderInfoResponse?.certNo,
          balance: parseFen2Yuan(orderInfoResponse?.balance || 0),
          expectedArrivalTime: orderInfoResponse?.expectedArrivalTime
            ? moment(orderInfoResponse?.expectedArrivalTime)
            : '',
          expectedDepartureTime: orderInfoResponse?.expectedDepartureTime
            ? moment(orderInfoResponse?.expectedDepartureTime)
            : '',
        };
        consumeBills = consumeBills?.map((item) => ({
          ...item,
          amount: parseFen2Yuan(item.amount),
          discountAmount: parseFen2Yuan(item.discountAmount),
        }));
        paymentBills = paymentBills?.map((item) => ({
          ...item,
          amount: parseFen2Yuan(item.amount),
          refundAmount: parseFen2Yuan(item.refundAmount),
        }));
        Object.keys(accountTotal)?.forEach((key) => {
          accountTotal[key] = parseFen2Yuan(accountTotal[key]);
        });
      }
    } catch (error) {
      //
    } finally {
      dispatch(toggleLoading('printInfoListLoading'));
      dispatch({
        type: actionTypes.PRINT_INFO_LIST_LOADING,
        payload: {
          orderInfoResponse: orderInfoObj,
          consumeBills,
          paymentBills,
          accountTotal,
          hotelBasicInfoResp,
        },
      });
    }
  };
};
